<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <h2 class="blind">약관동의 및 실명확인</h2>

      <!-- 본인확인 및 가입동의인증 안내 EligibilitySection -->
      <div class="registration-page">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>본인확인 및 가입동의인증 안내</h3>
            </div>
            <div class="section-body">
              <ul class="notice-text-list">
                <li class="notice-text">
                  가입신청완료를 위해 다음 중 한가지 인증수단이 반드시
                  필요합니다. 가능한 인증수단을 선택해주세요.
                </li>
                <li class="notice-text">
                  체크카드 및 은행, 증권거래용 인증서는 인증이 불가합니다.
                </li>
              </ul>

              <div class="field-group">
                <div class="field-label">
                  <label>인증수단</label>
                </div>
                <div class="field-control">
                  <div class="field-control-sub">
                    <div
                      id="radio-button-container-certificate"
                      class="input-container"
                    >
                      <input
                        id="select-verify-certification"
                        ref="onetAutnDivsCd"
                        v-model="onetAutnDivsCd"
                        type="radio"
                        name="eligibility-method"
                        value="04"
                        class="input-radio"
                        title="보유한 인증수단 선택"
                      />
                      <label
                        for="select-verify-certification"
                        class="input-label"
                        >본인 명의의 범용공동인증서</label
                      >
                    </div>

                    <div
                      id="radio-button-container-credit-card"
                      class="input-container"
                    >
                      <input
                        id="select-verify-credit-card"
                        v-model="onetAutnDivsCd"
                        type="radio"
                        name="eligibility-method"
                        value="06"
                        class="input-radio"
                        title="보유한 인증수단 선택"
                      />
                      <label for="select-verify-credit-card" class="input-label"
                        >가입자 본인명의(청소년 가입자는 법정대리인 명의)의
                        신용카드</label
                      >
                    </div>

                    <div
                      v-if="
                         $store.state.openMarketInfo.registrationTypeCode ==='chg' ||
                         $store.state.openMarketInfo.registrationTypeCode === 'renew'
                      "
                      id="radio-button-container-mobile-phone"
                      class="input-container"
                    >
                      <input
                        id="select-verify-uplus-phone"
                        v-model="onetAutnDivsCd"
                        type="radio"
                        name="eligibility-method"
                        value="03"
                        class="input-radio"
                        title="보유한 인증수단 선택"
                      />
                      <label for="select-verify-uplus-phone" class="input-label"
                        >LG유플러스에 가입하신 본인 명의의 휴대폰(기기변경
                        신청시에만 가능합니다)</label
                      >
                    </div>

                    <div
                      id="radio-button-container-no-eligibility-method"
                      class="input-container"
                    >
                      <input
                        id="select-verify-nothing"
                        v-model="onetAutnDivsCd"
                        type="radio"
                        name="eligibility-method"
                        value="N"
                        class="input-radio"
                      />
                      <label for="select-verify-nothing" class="input-label"
                        >위의 인증수단이 없습니다</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="onetAutnDivsCd === 'N'" class="field-group">
                <div class="field-label">
                  <label>가입진행 불가안내</label>
                </div>
                <div class="field-control">
                  <p class="data-text">
                    죄송합니다.<br />
                    <em class="primary-text"
                      >제시된 인증수단 중 1가지를 선택해야 온라인 가입을 진행할
                      수 있습니다.</em
                    ><br />
                    가입을 원하시면, 대리점으로 문의주시기 바랍니다.
                  </p>
                </div>
              </div>

              <div
                v-if="onetAutnDivsCd !== 'N' && onetAutnDivsCd !== ''"
                class="field-group"
              >
                <div class="field-label">
                  <label>인증절차 동의안내</label>
                </div>
                <div class="field-control">
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      고객님 LG유플러스 가입 신청을 환영합니다.
                    </li>
                    <li class="notice-text">
                      온라인에서 휴대폰을 구매하시고자 하는 고객님은 본인확인및
                      가입동의 절차를 위해 범용공동인증, 신용카드 인증 중 한가지
                      인증절차를 반드시 거치셔야 가입이 가능합니다.
                    </li>
                    <li class="notice-text">
                      온라인 비대면 판매절차로 인한 고객님의 피해를
                      최소화하고자하는 안전장치이오니 번거로우시더라도 널리 양해
                      바랍니다.
                    </li>
                    <li
                      class="notice-text"
                      v-if="$store.state.openMarketInfo.msBsType === 'BS'"
                    >
                      신규개통시에는 본인확인 인증에 구분 없이 임직원 사원증
                      제출이 필요합니다.
                    </li>
                  </ul>

                  <div class="field-control-sub">
                    <table class="section-grid">
                      <caption>
                        인증유형 안내 표
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">구분</th>
                          <th scope="col">대상</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>범용공동인증</td>
                          <td>범용공동인증서 보유 고객</td>
                        </tr>
                        <tr>
                          <td>신용카드인증</td>
                          <td>가입명의자 신용카드 보유 고객</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- <div class="field-control-sub">
                    <br />
                    <ul class="notice-text-list">
                      <li class="notice-text">
                        신규개통시에는 아래 추가서류 제출이 필요합니다.
                      </li>
                    </ul>
                    <table class="section-grid">
                      <caption>
                        신규개통시 추가 제출서류 안내 표
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">구분</th>
                          <th scope="col">사업자등록증</th>
                          <th scope="col">사원증</th>
                          <th scope="col">가족관계증명서</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>사업주</td>
                          <td>제출필요</td>
                          <td>-</td>
                          <td class="last">-</td>
                        </tr>
                        <tr>
                          <td>사원</td>
                          <td>제출필요</td>
                          <td>제출필요</td>
                          <td class="last">-</td>
                        </tr>
                        <tr>
                          <td>가족</td>
                          <td>-</td>
                          <td>제출필요</td>
                          <td class="last">제출필요</td>
                        </tr>
                      </tbody>
                    </table>
                    <ul class="notice-text-list">
                      <li class="notice-text">
                        사원증 대체서류 : 재직증명서 또는 근무확인서 또는
                        직장의료보험증 (단, 회사명과 부서명 필수)
                      </li>
                    </ul>
                  </div> -->

                  <div
                    id="checkbox-container-agreement"
                    class="input-container"
                  >
                    <input
                      id="verification-way-agreement"
                      ref="eligibilityAgreeChk"
                      v-model="eligibilityAgreeChk"
                      type="checkbox"
                      class="input-checkbox input-text"
                      title="상기 인증절차를 이해했으며 동의합니다"
                    />
                    <label for="verification-way-agreement" class="input-label"
                      ><em class="primary-text">(필수)</em> 상기내용을
                      이해하였으며 동의합니다.</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 이용약관 TermConditionSection -->
      <div class="registration-page">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>이용약관</h3>
            </div>
            <div class="section-body">

              <div
                :id="'accordion-all-detail-step1'"                
              >
                <dl class="field-group">
                  <dd class="field-control-step1">
                    <ul>
                    <li class="accordion type-01">
                      <div
                        :id="'accordion-required-all'"
                        class="accordion-title"
                        role="heading"
                      >
                        <div
                          class="input-container"
                        >     
                          <input
                            @change="checkAll"
                            type="checkbox"
                            id="agreement-all"
                            value="agreement-all"
                            class="input-checkbox input-text"
                            title="이용약관 전체동의"
                          />
                          <label for="agreement-all" class="input-label">전체동의                  
                            <div class="field-control-sub">
                              <ul class="notice-text-list">
                                <li class="notice-text">
                                  전체동의는 필수 및 선택동의가 포함되어 있으며 개별동의를 원하실 경우 펼쳐보기를 선택하여주십시요
                                </li>
                              </ul>
                            </div>
                          </label>
                        </div>                                         
                        <button
                          class="fold-button"
                          @click="showHideAccordionStep1('all')"
                          title="자세히보기"
                          tabindex="0"
                          :area-controls="'accordion-all-detail'"
                          :id="'all-show'"
                        ></button>
                      </div>
                    </li>
                    </ul>
                  </dd>
                </dl>      
              </div>

              <div
                :id="'accordion-all-detail'"
                class="accordion-detail"
                tabindex="0"
                :aria-labelledby="'all-show'"
                role="region"
              >

                <!-- 필수동의 Title  -->
                <div
                  :id="'accordion-req-detail-step1'"                
                >
                  <dl class="field-group">
                    <dd class="field-control-step1">
                      <ul>
                      <li class="accordion type-01">
                        <div
                          :id="'accordion-required-req'"
                          class="accordion-title"
                          role="heading"
                        >
                          <div
                            class="input-container"
                          >     
                            <input
                            @change="checkReqAll"
                            type="checkbox"
                            id="agreement-req"
                            value="agreement-req"
                            class="input-checkbox input-text"
                            title="이용약관 필수동의"
                            />
                            <label for="agreement-req"
                              class="input-label"
                              >이용약관 동의 <em class="primary-text">(필수)</em></label
                            >
                          </div>                                         
                          <button
                            class="fold-button"
                            @click="showHideAccordionStep1('req')"
                            title="자세히보기"
                            tabindex="0"
                            :area-controls="'accordion-req-detail'"
                            :id="'req-show'"
                          ></button>
                        </div>
                      </li>
                      </ul>
                    </dd>
                  </dl>      
                </div>

                <!-- 필수약관 -->
                <div
                  :id="'accordion-req-detail'"
                  class="accordion-detail"
                  tabindex="0"
                  :aria-labelledby="'req-show'"
                  role="region"
                >
                  <dl class="field-group">
                    <dt class="field-label">
                      <label
                        ></label
                      >
                    </dt>
                    <dd class="field-control">
                      <ul>
                        <li
                          class="accordion type-01"
                          v-for="termCondition in this.reqTermConditionList"
                          v-bind:key="termCondition.svcToaId"
                        >
                          <div
                            :id="'accordion-required-' + termCondition.svcToaId"
                            class="accordion-title"
                            role="heading"
                          >
                            <div
                              :id="'checkbox-container-' + termCondition.svcToaId"
                              class="input-container"
                            >
                              <input
                                :id="'accordion-checkbox-' + termCondition.svcToaId"
                                type="checkbox"
                                :name="termCondition.svcToaId"
                                @click="clickedReqAgreement"
                                class="input-checkbox input-text"
                                v-model="
                                  checkedRequiredTermsStatus[termCondition.svcToaId]
                                "
                                ref="checkedRequiredTermsStatus"
                              />
                              <label
                                class="input-label"
                                :for="
                                  'accordion-checkbox-' + termCondition.svcToaId
                                "
                                >{{ termCondition.svcToaNm }}</label
                              >
                            </div>
                            <button
                              class="fold-button"
                              @click="showHideAccordion(termCondition.svcToaId)"
                              title="자세히보기"
                              tabindex="0"
                              :area-controls="
                                'accordion-' + termCondition.svcToaId + '-detail'
                              "
                              :id="termCondition.svcToaId + '-show'"
                            ></button>
                          </div>

                          <div
                            :id="'accordion-' + termCondition.svcToaId + '-detail'"
                            class="accordion-detail"
                            tabindex="0"
                            :aria-labelledby="termCondition.svcToaId + '-show'"
                            role="region"
                          >
                            <p
                              v-if="
                                termCondition.svcToaId === 'requiredForUPlusService'
                              "
                              v-html="requiredForUPlusService"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForConciergeDeviceOnlyOneInformation'
                              "
                              v-html="requiredForConciergeDeviceOnlyOneInformation"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForPersonalInformation'
                              "
                              v-html="requiredForPersonalInformation"
                            />
                            <!-- ST 이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가-->
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForPersonalLocationInformation'
                              "
                              v-html="requiredForPersonalLocationInformation"
                            />
                            <!-- ED 이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가-->
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForServiceProviding'
                              "
                              v-html="requiredForServiceProviding"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForCreditInformation'
                              "
                              v-html="requiredForCreditInformation"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForConciergeDeviceSaleUse'
                              "
                              v-html="requiredForConciergeDeviceSaleUse"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId === 'optionalMarketingOffer'
                              "
                              v-html="optionalMarketingOffer"
                            />
                            <!-- 광고전송 동의 추가 -->
                            <p
                              v-if="
                                termCondition.svcToaId === 'optionalMarketingOfferAds'
                              "
                              v-html="optionalMarketingOfferAds"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'optionalMarketingOfferPersonal'
                              "
                              v-html="optionalMarketingOfferPersonal"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'optionalMarketingOfferPersonalTrst'
                              "
                              v-html="optionalMarketingOfferPersonalTrst"
                            />                            
                            <p
                              v-if="
                                termCondition.svcToaId === 'requiredForMobileRouter'
                              "
                              v-html="requiredForMobileRouter"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId === 'requiredForMobileMove'
                              "
                              v-html="requiredForMobileMove"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForMobileFeeSupport'
                              "
                              v-html="requiredForMobileFeeSupport"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForConciergeDeviceInstallment'
                              "
                              v-html="requiredForConciergeDeviceInstallment"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForMobileInstallment'
                              "
                              v-html="requiredForMobileInstallment"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForLocationServiceInformationOffer'
                              "
                              v-html="requiredForLocationServiceInformationOffer"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForAsianaMileage'
                              "
                              v-html="requiredForAsianaMileage"
                            />
                          </div>
                        </li>
                      </ul>
                    </dd>
                  </dl>
                </div>

                <!-- 필수동의 Title  -->
                <div
                  :id="'accordion-opt-detail-step1'"                
                >
                  <dl class="field-group">
                    <dd class="field-control-step1">
                      <ul>
                      <li class="accordion type-01">
                        <div
                          :id="'accordion-required-opt'"
                          class="accordion-title"
                          role="heading"
                        >
                          <div
                            class="input-container"
                          >     
                            <input
                            @change="checkOptAll"
                            type="checkbox"
                            id="agreement-opt"
                            value="agreement-opt"
                            class="input-checkbox input-text"
                            title="이용약관 필수동의"
                            />
                            <label for="agreement-opt"
                              class="input-label">이용약관 동의 (선택)</label>
                          </div>                                         
                          <button
                            class="fold-button"
                            @click="showHideAccordionStep1('opt')"
                            title="자세히보기"
                            tabindex="0"
                            :area-controls="'accordion-opt-detail'"
                            :id="'opt-show'"
                          ></button>
                        </div>
                      </li>
                      </ul>
                    </dd>
                  </dl>      
                </div>

                <!-- 선택약관 -->
                <div
                  :id="'accordion-opt-detail'"
                  class="accordion-detail"
                  tabindex="0"
                  :aria-labelledby="'opt-show'"
                  role="region"
                >
                  <dl class="field-group">
                    <dt class="field-label">
                      <label></label>
                    </dt>
                    <dd class="field-control">
                      <ul>
                        <li
                          class="accordion type-01"
                          v-for="termCondition in this.optTermConditionList"
                          v-bind:key="termCondition.svcToaId"
                        >
                          <div
                            :id="'accordion-required-' + termCondition.svcToaId"
                            class="accordion-title"
                            role="heading"
                          >
                            <div
                              :id="'checkbox-container-' + termCondition.svcToaId"
                              class="input-container"
                            >
                              <input
                                :id="'accordion-checkbox-' + termCondition.svcToaId"
                                type="checkbox"
                                :name="termCondition.svcToaId"
                                @click="clickedOptAgreement"
                                class="input-checkbox input-text"
                                v-model="
                                  checkedOptionTermsStatus[termCondition.svcToaId]
                                "
                              />
                              <label
                                class="input-label"
                                :for="
                                  'accordion-checkbox-' + termCondition.svcToaId
                                "
                                >{{ termCondition.svcToaNm }}</label
                              >
                            </div>
                            <button
                              class="fold-button"
                              @click="showHideAccordion(termCondition.svcToaId)"
                              title="자세히보기"
                              tabindex="0"
                              :area-controls="
                                'accordion-' + termCondition.svcToaId + '-detail'
                              "
                              :id="termCondition.svcToaId + '-show'"
                            ></button>
                          </div>

                          <div
                            :id="'accordion-' + termCondition.svcToaId + '-detail'"
                            class="accordion-detail"
                            tabindex="0"
                            :aria-labelledby="termCondition.svcToaId + '-show'"
                            role="region"
                          >
                            <p
                              v-if="
                                termCondition.svcToaId === 'requiredForUPlusService'
                              "
                              v-html="requiredForUPlusService"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForConciergeDeviceOnlyOneInformation'
                              "
                              v-html="requiredForConciergeDeviceOnlyOneInformation"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForPersonalInformation'
                              "
                              v-html="requiredForPersonalInformation"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForServiceProviding'
                              "
                              v-html="requiredForServiceProviding"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForCreditInformation'
                              "
                              v-html="requiredForCreditInformation"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForConciergeDeviceSaleUse'
                              "
                              v-html="requiredForConciergeDeviceSaleUse"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId === 'optionalMarketingOffer'
                              "
                              v-html="optionalMarketingOffer"
                            />
                            <!-- 광고전송 동의 추가 -->
                            <p
                              v-if="
                                termCondition.svcToaId === 'optionalMarketingOfferAds'
                              "
                              v-html="optionalMarketingOfferAds"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'optionalMarketingOfferPersonal'
                              "
                              v-html="optionalMarketingOfferPersonal"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'optionalMarketingOfferPersonalTrst'
                              "
                              v-html="optionalMarketingOfferPersonalTrst"
                            />                            
                            <!-- 처리위탁 유통점 추가 시작 C20210407_06398_4406398 -->
                            <br/>
                            <span  v-if=" termCondition.svcToaId ==='optionalMarketingOfferPersonalTrst'"
                              class="dynamic-data-temp">처리위탁 유통점 : {{ $store.state.openMarketInfo.agentName }}</span>
                            <!-- 처리위탁 유통점 추가 끝 C20210407_06398_4406398 -->
                            <p
                              v-if="
                                termCondition.svcToaId === 'requiredForMobileRouter'
                              "
                              v-html="requiredForMobileRouter"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId === 'requiredForMobileMove'
                              "
                              v-html="requiredForMobileMove"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForMobileFeeSupport'
                              "
                              v-html="requiredForMobileFeeSupport"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForConciergeDeviceInstallment'
                              "
                              v-html="requiredForConciergeDeviceInstallment"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForMobileInstallment'
                              "
                              v-html="requiredForMobileInstallment"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForLocationServiceInformationOffer'
                              "
                              v-html="requiredForLocationServiceInformationOffer"
                            />
                            <p
                              v-if="
                                termCondition.svcToaId ===
                                  'requiredForAsianaMileage'
                              "
                              v-html="requiredForAsianaMileage"
                            />
                          </div>
                        </li>
                      </ul>
                    </dd>
                  </dl> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="registration-page">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>실명확인</h3>
            </div>

            <div class="section-body">
              <ul class="notice-text-list">
                <li class="notice-text">
                  실명인증을 위해 가입자 본인 성명 및 주민등록번호를 입력하시고
                  실명인증 버튼을 눌러주시기 바랍니다.
                </li>
                <li class="notice-text">
                  타인의 정보 및 주민등록번호를 도용하는 경우 3년 이하의 징역
                  또는 1천만원 이하의 벌금에 처해지게 됩니다.
                </li>
                <li class="notice-text">
                  가입자가 청소년일 경우 청소년 본인의 실명을 확인해 주시기
                  바랍니다.
                </li>
              </ul>

              <div class="field-group">
                <div class="field-label">
                  <label>내외국인 구분</label>
                </div>
                <div class="field-control">
                  <div>
                    <div
                      id="radio-button-container-korean"
                      class="input-container input-horizontal"
                    >
                      <input
                        ref="ref_nationality"
                        id="id-nationality-local"
                        v-model="nationality"
                        type="radio"
                        name="nationality"
                        value="korean"
                        @change="changeNationality"
                        class="input-radio"
                        title="내외국인 구분 선택"
                      />
                      <label for="id-nationality-local" class="input-label"
                        >내국인</label
                      >
                    </div>
                    <div
                      id="radio-button-container-foreigner"
                      class="input-container input-horizontal"
                    >
                      <input
                        ref="ref_foreigner_nationality"
                        id="id-nationality-foreigner"
                        v-model="nationality"
                        type="radio"
                        name="nationality"
                        value="foreigner"
                        @change="changeNationality"
                        class="input-radio"
                        title="내외국인 구분 선택"
                      />
                      <label for="id-nationality-foreigner" class="input-label"
                        >외국인(Foreigner)</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="field-group">
                <div class="field-label">
                  <label
                    >이름&nbsp;<span v-if="nationality !== 'korean'"
                      >(Name)</span
                    ></label
                  >
                </div>
                <div class="field-control">
                  <div>
                    <input
                      v-model="name"
                      type="text"
                      name="name"
                      autocomplete="off"
                      ref="ref_name"
                      @input="onlyText"
                      class="input-text input-width-medium input-font input-horizontal"
                      title="성명입력"
                    />

                    <div
                      v-if="nationality === 'korean'"
                      id="checkbox-container-teenager"
                      class="input-container"
                    >
                      <input
                        ref="ref_checkBox"
                        id="check-teenager-customer"
                        v-model="isTeenager"
                        type="checkbox"
                        name="teenager"
                        value="teenager"
                        class="input-checkbox input-text"
                        title="만 18세 이하 청소년일 경우 선택"
                      />
                      <label for="check-teenager-customer" class="input-label"
                        >청소년 (만 18세 이하)</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="field-group">
                <div class="field-label">
                  <label v-if="nationality !== 'foreigner'">주민등록번호</label>
                  <label v-if="nationality !== 'korean'"
                    >외국인등록번호<br /><span
                      >(Alien Registration Number)</span
                    ></label
                  >
                </div>
                <div class="field-control">
                  <div class="field-control-sub m-input-half">
                    <span
                      ><input
                        ref="ref_ssn1"
                        v-model="ssn1"
                        type="text"
                        name="ssn1"
                        autocomplete="off"
                        @input="onlyNumber"
                        class="input-text input-width-xsmall input-font"
                        maxlength="6"
                        title="주민등록번호 앞 여섯자리 입력"
                    /></span>

                    <span class="field-group-space">-</span>
                    <span
                      ><input
                        ref="ref_ssn2"
                        v-model="ssn2"
                        type="password"
                        name="ssn2"
                        autocomplete="new-password"
                        class="input-text input-width-xsmall input-font "
                        maxlength="7"
                        @input="onlyNumber"
                        title="주민등록번호 뒤 일곱자리 입력"
                    /></span>
                  </div>

                  <div v-if="nationality === 'foreigner'">
                    <div class="field-control-sub">
                      <div
                        id="checkbox-container-foreignerAgree"
                        class="input-container"
                      >
                        <input
                          id="alien-registration-number-agreement"
                          v-model="foreignerAgree"
                          type="checkbox"
                          name="foreignerAgree"
                          class="input-checkbox input-text"
                          title="외국인등록번호 수집 및 이용 동의 확인"
                        />
                        <label
                          @click="foreignerAgreePopup"
                          for="alien-registration-number-agreement"
                          class="input-label"
                          ><em class="primary-text">(필수)</em> 외국인등록번호
                          수집, 이용 동의
                        </label>
                      </div>
                    </div>
                    <div class="field-control-sub">
                      <ul class="notice-text-list">
                        <li class="notice-text">
                          수집이용 목적 : 본인확인, 본인인증, 미환급금안내,
                          실명인증
                        </li>
                        <li class="notice-text">
                          수집정보의 항목 : 외국인등록번호(본인, 대리인 신분확인
                          이미지 및 내용 포함)
                        </li>
                        <li class="notice-text">
                          정보의 보유 및 이용기간
                          <div class="notice-text">
                            서비스 가입기간 동안 이용하고, 요금정산과
                            오납분쟁대비를 위해 해지 후 요금완납 후 6개월 까지
                            이용
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="section-separator"></div>
                  <div class="form-control-sub m-input-half">
                    <button
                      type="submit"
                      @click="verifyCustomerIdentification"
                      class="m-right"
                      ref="verifiedSsn"
                    >
                      실명확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="step-bottom-area input-wrap">
        <button
          type="button"
          class="normal-button mw30 float-left"
          @click="backToPreviousStep"
        >
          이전
        </button>
        <button
          type="submit"
          class="primary-button mw100 pc-float-right"
          @click="saveAndContinueToStep2"
        >
          다음으로 이동
        </button>
      </div>
    </div>

    <v-dialog />
    <ForeignerAgreePopup @close="popupForeignerClose" />
  </div>
</template>

<script>
import { watchRefreshKeyPress } from '@/system/common'
import { verify } from '@/api/ucube'
import { router } from '@/router/router'
import { actionType } from '@/store'
import { getRegistrationForm } from '@/api/captureService'
import { getOpenMarketInfo } from '@/api/openmarket'
// HARD 코딩 데이터라 삭제 불가
import { metaServiceRepo } from '@/repository/metaServiceHardCodedDataRepo'
import ForeignerAgreePopup from '@/components/openMarket/popup/ForeignerAgreePopup'

export default {
  name: 'RegistrationStep1',

  components: {
    ForeignerAgreePopup
  },

  props: {},

  computed: {
    requiredForUPlusService() {
      let fileName = 'agree1.html'
      if (this.isConciergeDevice) {
        fileName = 'agree1_cdevice.html'
      }

      return require('html-loader!~/html/appl/' + fileName)
    },
    requiredForConciergeDeviceOnlyOneInformation() {
      return require('html-loader!~/html/appl/agree2_cdevice.html')
    },
    requiredForPersonalInformation() {
      let fileName = 'agree2.html'
      if (this.isNote7) fileName = 'agree2_SM_N930L.html'
      return require('html-loader!~/html/appl/' + fileName)
    },
    requiredForPersonalLocationInformation(){//이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가
      return require('html-loader!~/html/appl/agree_personal_location.html')
    },
    requiredForServiceProviding() {
      return require('html-loader!~/html/appl/longdesc_agree7.html')
    },
    requiredForCreditInformation() {
      let fileName = 'agree11.html'
      if (this.isConciergeDevice) fileName = 'agree3_cdevice.html'
      return require('html-loader!~/html/appl/' + fileName)
    },
    requiredForConciergeDeviceSaleUse() {
      //  컨시어지 디바이스 용 약관동의 ~/html/appl/agree4_cdevice.html
      return require('html-loader!~/html/appl/agree4_cdevice.html')
    },
    optionalMarketingOffer() {
      //  고객 혜택정보/광고 정보 제공을 위한 동의(선택동의) => 24.05.02 고객 혜택정보 제공을 위한 정보 수집 ·이용 동의
      return require('html-loader!~/html/appl/agree8.html')
    },
    // 광고전송 동의 추가
    optionalMarketingOfferAds() {
      //  광고전송 동의(선택동의
      return require('html-loader!~/html/appl/agree9.html')
    },
    optionalMarketingOfferPersonal() {
      //  고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 동의(선택동의) => 24.05.02 혜택정보 · 광고 수신 동의
      return require('html-loader!~/html/appl/agree10.html')
    },
    optionalMarketingOfferPersonalTrst() {
      //  24.05.02 고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내
      return require('html-loader!~/html/appl/agree16.html')
    },    
    requiredForMobileRouter() {
      //  모바일라우터 의무약정 조항(필수동의)
      return require('html-loader!~/html/appl/agree5_router.html')
    },
    requiredForMobileMove() {
      //  번호 이동 신청 동의(필수동의)
      return require('html-loader!~/html/appl/agree3.html')
    },
    requiredForMobileFeeSupport() {
      //  휴대폰 구입 비용 지원 신청 동의(필수동의)
      return require('html-loader!~/html/appl/agree4.html')
    },
    requiredForConciergeDeviceInstallment() {
      //  컨시어지 디바이스 용 약관동의
      return require('html-loader!~/html/appl/agree5_cdevice.html')
    },
    requiredForMobileInstallment() {
      // 휴대폰 할부계약 약정조항(필수동의)
      return require('html-loader!~/html/appl/agree5.html')
    },
    requiredForLocationServiceInformationOffer() {
      // 위치 기반 서비스 정보 제공 및 동의 (필수동의)
      return require('html-loader!~/html/appl/agree6_cdevice.html')
    },
    requiredForAsianaMileage() {
      // 개인정보 수집 이용 동의서(사은품 발송 및 경품행사용)
      return require('html-loader!~/html/appl/agree_asiana.html')
    }
  },

  data() {
    return {
      name: '',
      ssn1: '',
      ssn2: '',
      emailId: '',
      emailDomain: '',
      custKdCd: '',
      autnMthdDivsCd: '',
      onetAutnDivsCd: '',// 인증구분 추가 온세일 장희정 2023.09.14
      custInfoGthrAgrYn: '',
      pnifPuseTrstAgrYn: '',
      locFndnInfoOfrSvcAgrYn: '',

      eligibilityAgreeChk: false,

      isConciergeDevice: true,
      isNote7: false,
      isMove: false,
      isChange: false,
      isRouter: false,
      isAsiana: false,
      inputFileName: '',

      reqTermConditionList: [],
      optTermConditionList: [],
      checkedRequiredTermsStatus: {},
      checkedOptionTermsStatus: {},

      isTeenager: false,
      nationality: 'korean',
      foreignerAgree: false,
      verifiedSsn: false
    }
  },

  created() {
    watchRefreshKeyPress()
    this.foreignerAgree = false
    this.nationality = 'korean'
  },

  mounted() {
    this.$store.state.processIndicator.step1 = true
    this.$store.state.processIndicator.step2 = false
    this.$store.state.processIndicator.step3 = false
    this.$store.state.processIndicator.step4 = false
    this.isConciergeDevice =
      this.$store.state.openMarketInfo.mblSvcDivsCd === 'WDLR-LU001-R'
        ? true
        : false
    this.getTermConditionList()
    let params = this.getUrlParams()
    if (Object.keys(params).length > 0) {
      if (params.accessType !== 'E') {
        router.replace({
          name: 'Error',
          props: true,
          params: {
            message:
              '현재 접근 하신 경로는 올바르지 않은 접속 경로 입니다.\n올바른 경로를 통하여 다시 접속하여 주세요.',
            type: 'access'
          }
        })
        return
      }
      this.initPage(params.appfNo)
    } else {
      if (!this.$store.state.openMarketInfo.entrRqstFomNo) {
        router.replace({
          name: 'Error',
          props: true,
          params: {
            message:
              '현재 접근 하신 경로는 올바르지 않은 접속 경로 입니다.\n올바른 경로를 통하여 다시 접속하여 주세요.',
            type: 'access'
          }
        })
        return
      }
    }
  },

  methods: {
    /** 
     * Function    : onlyNumber
     * Description : input값 숫자 체크
     **/
    onlyNumber(e) {
      if(e.target.name === 'ssn1') this.ssn1 = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'ssn2') this.ssn2 = e.target.value.replace(/[^0-9]/gi, '')
    },

    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      if(e.target.name === 'name') this.name = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },

    /** 
     * Function    : initPage
     * Description : 초기 페이지 진입시 이메일로 접근하면, 신청서 정보와 양식 정보 가져오기
     **/
    initPage(crypAppfNo) {
      if (crypAppfNo !== '') {
        getRegistrationForm(crypAppfNo).then(res => {
          let apiResponseJson = res.data
          let registration = apiResponseJson.opmktRegistrationCapture // registration 저장
          if(!registration.sbgnDealCd || !registration.entrRqstFomNo || !registration.opmkNo) {
              this.openAlert(
                '온라인 가입신청 안내',
                '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
              )
              return
          }
          getOpenMarketInfo(
            registration.sbgnDealCd,
            registration.entrRqstFomNo,
            registration.opmkNo
          ).then(res => {
            this.$store.state.openMarketInfo = res.data
            this.$store.state.openMarketInfo.agentId = registration.sbgnDealCd
            this.$store.state.openMarketInfo.dealCd = registration.sbgnDealCd
            this.$store.state.openMarketInfo.formId = registration.entrRqstFomNo
            this.$store.state.openMarketInfo.entrRqstFomNo =
              registration.entrRqstFomNo
            this.$store.state.openMarketInfo.openMarketCode =
              registration.opmkNo
            if (!this.$store.state.openMarketInfo.entrRqstFomNo) {
              router.replace({
                name: 'Error',
                props: true,
                params: {
                  message:
                    '현재 접근 하신 경로는 올바르지 않은 접속 경로 입니다.\n올바른 경로를 통하여 다시 접속하여 주세요.',
                  type: 'access'
                }
              })
            }
          })
        })
      }
    },

    /** 
     * Function    : getUrlParams
     * Description : 임시저장에서 이메일로 들어온 경우
     **/
    getUrlParams() {
      var params = {}
      window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
        str,
        key,
        value
      ) {
        params[key] = value
      })
      return params
    },

    /** 
     * Function    : getTermConditionList
     * Description : meta에서 약관전체 리스트
     **/
    getTermConditionList() {
      const termConditionResponsePromise = metaServiceRepo.getTermConditionList()
    //* 장희정 추가   2020.09.05
     if( this.$store.state.openMarketInfo.registrationTypeCode==="chg"||this.$store.state.openMarketInfo.registrationTypeCode==="renew"){
       this.isChange=true;
     }else if( this.$store.state.openMarketInfo.registrationTypeCode==="move"){
       this.isMove=true;
     }
    // 라우터
     if(this.$store.state.openMarketInfo.rotrRqstCd==="Y" && this.$store.state.openMarketInfo.mblSvcDivsCd==="LZP0002200"){
       this.isRouter=true;
     }

      if (termConditionResponsePromise !== undefined) {
        termConditionResponsePromise.then(response => {
          response.json().then(jsonResponse => {
            if (this.isConciergeDevice) {
              this.reqTermConditionList = jsonResponse.filter(termCondition => {
                return (
                  termCondition.req &&
                  (termCondition.svcType === 'GD' ||
                    termCondition.svcType === 'G' ||
                    termCondition.svcType === 'D' ||
                    (this.isMove && termCondition.svcType === 'T') ||
                    (this.isChange && termCondition.svcType === 'CR') ||
                    (this.isRouter && termCondition.svcType === 'R'))
                )
              })
              this.reqTermConditionList.forEach(termAndCondition => {
                this.checkedRequiredTermsStatus[
                  termAndCondition.svcToaId
                ] = false
              })

              this.optTermConditionList = jsonResponse.filter(termCondition => {
                return (
                  !termCondition.req &&
                  (termCondition.svcType === 'GD' ||
                    termCondition.svcType === 'G' ||
                    termCondition.svcType === 'D' ||
                    (this.isMove && termCondition.svcType === 'T') ||
                    (this.isChange && termCondition.svcType === 'CR') ||
                    (this.isRouter && termCondition.svcType === 'R'))
                )
              })
              this.optTermConditionList.forEach(termAndCondition => {
                this.checkedOptionTermsStatus[termAndCondition.svcToaId] = false
              })
            } else {
              this.reqTermConditionList = jsonResponse.filter(termCondition => {
                return (
                  termCondition.req &&
                  (termCondition.svcType === 'GD' ||
                    termCondition.svcType === 'G' ||
                    (this.isMove && termCondition.svcType === 'T') ||
                    (this.isChange && termCondition.svcType === 'CR') ||
                    (this.isRouter && termCondition.svcType === 'R'))
                )
              })
              this.reqTermConditionList.forEach(termAndCondition => {
                this.checkedRequiredTermsStatus[
                  termAndCondition.svcToaId
                ] = false
              })

              this.optTermConditionList = jsonResponse.filter(termCondition => {
                return (
                  !termCondition.req &&
                  (termCondition.svcType === 'GD' ||
                    termCondition.svcType === 'G' ||
                    (this.isMove && termCondition.svcType === 'T') ||
                    (this.isChange && termCondition.svcType === 'CR') ||
                    (this.isRouter && termCondition.svcType === 'R'))
                )
              })
              this.optTermConditionList.forEach(termAndCondition => {
                this.checkedOptionTermsStatus[termAndCondition.svcToaId] = false
              })
            }
          })
        })
      }
    },

    /** 
     * Function    : checkAll
     * Description : 약관 전체동의
     **/
    checkAll(checkAllEvent) {
        let agre_all = document.getElementById('agreement-all')
        let agre_req = document.getElementById('agreement-req')
        let agre_opt = document.getElementById('agreement-opt')
        if(agre_all.checked === true){
            agre_req.checked = true
            agre_opt.checked = true
        }else{
            agre_req.checked = false
            agre_opt.checked = false
        }

      this.reqTermConditionList.forEach(termCondition => {
        const elementId = 'accordion-checkbox-' + termCondition.svcToaId

        const htmlElement = document.getElementById(elementId)
        if (htmlElement != null) {
          htmlElement.checked = checkAllEvent.target.checked

          const simulatedEvent = {
            target: {
              name: termCondition.svcToaId,
              checked: checkAllEvent.target.checked
            }
          }

          this.clickedReqAgreement(simulatedEvent)
        }
      })

      this.optTermConditionList.forEach(termCondition => {
        const elementId = 'accordion-checkbox-' + termCondition.svcToaId

        const htmlElement = document.getElementById(elementId)
        if (htmlElement != null) {
          htmlElement.checked = checkAllEvent.target.checked

          const simulatedEvent = {
            target: {
              name: termCondition.svcToaId,
              checked: checkAllEvent.target.checked
            }
          }

          this.clickedOptAgreement(simulatedEvent)
        }
      })
    },
    /** 
     * Function    : checkReqAll
     * Description : 약관 필수동의
     **/
    checkReqAll(checkAllEvent) {
      this.reqTermConditionList.forEach(termCondition => {
        const elementId = 'accordion-checkbox-' + termCondition.svcToaId

        const htmlElement = document.getElementById(elementId)
        if (htmlElement != null) {
          htmlElement.checked = checkAllEvent.target.checked

          const simulatedEvent = {
            target: {
              name: termCondition.svcToaId,
              checked: checkAllEvent.target.checked
            }
          }

          this.clickedReqAgreement(simulatedEvent)
        }
      })
    },  
    checkOptAll(checkAllEvent) {
      this.optTermConditionList.forEach(termCondition => {
        const elementId = 'accordion-checkbox-' + termCondition.svcToaId

        const htmlElement = document.getElementById(elementId)
        if (htmlElement != null) {
          htmlElement.checked = checkAllEvent.target.checked

          const simulatedEvent = {
            target: {
              name: termCondition.svcToaId,
              checked: checkAllEvent.target.checked
            }
          }

          this.clickedOptAgreement(simulatedEvent)
        }
      })
    },    
    
    /** 
     * Function    : clickedReqAgreement
     * Description : 필수약관 동의
     **/
    clickedReqAgreement(event) {
      this.checkedRequiredTermsStatus[event.target.name] = event.target.checked
    },

    /** 
     * Function    : clickedOptAgreement
     * Description : 선택약관 동의
     **/
    clickedOptAgreement(event) {
      this.checkedOptionTermsStatus[event.target.name] = event.target.checked
    },

    /** 
     * Function    : backToPreviousStep
     * Description : 이전 스텝 이동
     **/
    backToPreviousStep() {
      this.$router.go(-1)
    },

    /** 
     * Function    : saveAndContinueToStep2
     * Description : Step1 저장 함수
     **/
    saveAndContinueToStep2() {
      if (!this.validationStep1()) return
      if (!this.validateNationality()) return

      this.custInfoGthrAgrYn = this.checkedRequiredTermsStatus[
        'requiredForPersonalInformation'
      ]
        ? 'Y'
        : 'N'
      this.pnifPuseTrstAgrYn = this.checkedOptionTermsStatus[
        'optionalMarketingOffer'
      ]
        ? 'Y'
        : 'N'
      this.locFndnInfoOfrSvcAgrYn = this.checkedOptionTermsStatus[
        'optionalMarketingOfferPersonal'
      ]
        ? 'Y'
        : 'N'
      // 광고 수신 동의 여부 추가
      this.mblAdRcpAgrYn = this.checkedOptionTermsStatus[
        'optionalMarketingOfferAds'
      ]
        ? 'Y'
        : 'N'

      this.$store.state.step1.customer.name = this.name
      this.$store.state.step1.customer.ssn1 = this.ssn1
      this.$store.state.step1.customer.ssn2 = this.ssn2
      this.$store.state.step1.customer.emailId = this.emailId
      this.$store.state.step1.customer.emailDomain = this.emailDomain
      this.validateCustType()
      this.$store.state.step1.customer.custKdCd = this.custKdCd

      this.$store.state.step1.onetAutnDivsCd = this.onetAutnDivsCd
      this.$store.state.step1.custInfoGthrAgrYn = this.custInfoGthrAgrYn
      this.$store.state.step1.pnifPuseTrstAgrYn = this.pnifPuseTrstAgrYn
      this.$store.state.step1.locFndnInfoOfrSvcAgrYn = this.locFndnInfoOfrSvcAgrYn
      this.$store.state.step1.mblAdRcpAgrYn = this.mblAdRcpAgrYn

      this.$router.push({
        name: 'RegistrationStep2'
      })
    },

    /** 
     * Function    : showHideAccordion
     * Description : 약관 accordion
     **/
    showHideAccordion(id) {
      const panel = document.getElementById('accordion-' + id + '-detail')
      if (panel.style.maxHeight)
        (panel.style.maxHeight = null),
          (panel.style.height = null),
          (panel.style.padding = '0 12px'),
          (panel.style.overflow = 'hidden'),
          (panel.style.visibility = 'hidden'),
          panel.previousElementSibling.classList.toggle('active')
      else
        (panel.style.maxHeight = '220px'),
          (panel.style.height = 'auto'),
          (panel.style.padding = '12px'),
          (panel.style.overflow = 'auto'),
          (panel.style.visibility = 'visible'),
          panel.previousElementSibling.classList.toggle('active')
    },

    /** 
     * Function    : showHideAccordion
     * Description : 약관 accordion
     **/
    showHideAccordionStep1(id) {
      const panel_step1 = document.getElementById('accordion-required-' + id)
      const panel = document.getElementById('accordion-' + id + '-detail')
      if (panel.style.maxHeight)
        (panel.style.maxHeight = null),
          (panel.style.height = null),
          (panel.style.padding = '0 12px'),
          (panel.style.overflow = 'hidden'),
          (panel.style.visibility = 'hidden'),
          panel_step1.classList.toggle('active')
      else
        (panel.style.maxHeight = '800px'),
          (panel.style.height = 'auto'),
          (panel.style.padding = '12px'),
          (panel.style.overflow = 'auto'),
          (panel.style.visibility = 'visible'),
          panel_step1.classList.toggle('active')
    },        

    /** 
     * Function    : validationStep1
     * Description : Step1 필수값 Validation
     **/
    validationStep1() {
      let title = '온라인 가입신청 안내'
      let regExp = ''
      if (!this.onetAutnDivsCd) {
        this.openAlert(
          title,
          '인증수단을 선택해주세요.',
          this.$refs.onetAutnDivsCd
        )
        return false
      }

      if (this.onetAutnDivsCd !== 'N' && this.onetAutnDivsCd !== '') {
        if (!this.eligibilityAgreeChk) {
          this.openAlert(
            title,
            '인증 절차 동의여부를 확인해주세요.',
            this.$refs.eligibilityAgreeChk
          )
          return false
        }
      }

      for (let i = 0; i < this.reqTermConditionList.length; i++) {
        let termCondition = this.reqTermConditionList[i]
        if (!this.checkedRequiredTermsStatus[termCondition.svcToaId]) {
          this.openAlert(
            title,
            '필수 동의여부를 확인해주세요.',
            this.$refs.checkedRequiredTermsStatus[i]
          )
          return false
        }
      }
      if (!this.verifiedSsn) {
        this.openAlert(
          title,
          '실명 인증을 완료해주세요.',
          this.$refs.verifiedSsn
        )
        return false
      }
      return true
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message, ref) {
      this.$modal.show('dialog', {
        text: message,
        title: title,
        buttons: [
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              if (ref) {
                ref.focus()
              }
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },

    /** 
     * Function    : verifyCustomerIdentification
     * Description : 실명인증 호출
     **/
    verifyCustomerIdentification() {
      let params = this.getUrlParams()
      let accessType = 'O'
      let crypAppfNo = ''
      if(!this.validateNationality()) return
      this.validateCustType()
      if (params.accessType) {
        accessType = params.accessType
        crypAppfNo = params.appfNo
      }
      let title = '온라인 가입신청 안내'
      let message = ''
      let info = {
        custType: this.custKdCd,
        accessType: accessType,
        dealCd: this.$store.state.openMarketInfo.dealCd,
        entrRqstFomNo: this.$store.state.openMarketInfo.formId,
        opmkNo: this.$store.state.openMarketInfo.openMarketCode,
        applType: this.$store.state.openMarketInfo.registrationTypeCode,
        appfNo: crypAppfNo
      }
      if (this.validateCustomerIdentificationInput()) {
        verify(this.name, this.ssn1, this.ssn2, info).then(res => {
          let response = res.data
          message = response.dsRes.msg
          
          if (response.dsRes.msgCd === 'S' || response.dsRes.msgCd === 'E') {
            this.setDisalbed();
            this.$store.state.step1.customer.aplcErrno = response.resultData.aplcErrno
            if (response.dsRes.msgCd === 'E') {
              this.$modal.show('dialog', {
                title: title,
                text: '실명확인이 되었습니다.',
                buttons: [
                  {
                    title: '확인',
                    class: 'primary-button',
                    handler: () => {
                      this.$store.dispatch(
                        actionType.saveApplicationNumber,
                        response.resultData.crypAppfNo
                      )
                      this.verifiedSsn = true
                      this.$modal.hide('dialog')
                    }
                  }
                ]
              })
            } else {
              this.$store.dispatch(actionType.saveApplicationNumber, '')
              this.verifiedSsn = true
            }
          } else {
            this.verifiedSsn = false
          }
          this.openAlert(title, message)
        })
      }
    },

    /** 
     * Function    : setDisalbed
     * Description : 실명인증 성공 후 input disabled처리
     **/
    setDisalbed() {
      this.$refs.ref_nationality.setAttribute("disabled","disabled");
      this.$refs.ref_foreigner_nationality.setAttribute("disabled","disabled");
      this.$refs.ref_name.setAttribute("disabled","disabled");
      if(this.nationality == 'korean') {
        this.$refs.ref_checkBox.setAttribute("disabled","disabled");
      } 
      this.$refs.ref_ssn1.setAttribute("disabled","disabled");
      this.$refs.ref_ssn2.setAttribute("disabled","disabled");
    },

    /** 
     * Function    : verifyCustomerIdentification
     * Description : 실명인증 필수값 Validation
     **/
    validateCustomerIdentificationInput() {
      let title = '온라인 가입신청 안내'
      let message = ''

      if (this.nationality === '') {
        message = '내외국인 구분을 선택해주세요.'
        this.openAlert(title, message, this.$refs.ref_nationality)
        return false
      }
      if (this.name === '') {
        message = '이름을 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_name)
        return false
      }
      let regExpNm = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9|\s]+$/
      if (!regExpNm.test(this.name)) {
        message = '이름은 한글, 영어, 숫자만 입력 가능합니다.'
        this.openAlert(title, message, this.$refs.ref_name)
        return false
      }
      if (this.ssn1 === '') {
        message = '주민번호 앞자리를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_ssn1)
        return false
      }
      let regExpSsn1 = /^[0-9]{6}$/
      if (!regExpSsn1.test(this.ssn1)) {
        message = '주민번호 앞자리는 6자리 숫자를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_ssn1)
        return false
      }
      if (this.ssn2 === '') {
        message = '주민번호 뒷자리를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_ssn2)
        return false
      }
      let regExpSsn2 = /^[0-9]{7}$/
      if (!regExpSsn2.test(this.ssn2)) {
        message = '주민번호 뒷자리는 7자리 숫자를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_ssn2)
        return false
      }
      return true
    },

    /** 
     * Function    : validateCustType
     * Description : 가입자 유형 명
     **/
    validateCustType() {
      this.checkTeenager()
      if (this.nationality === 'korean') {
        if (!this.isTeenager) {
          this.custKdCd = 'B'
        } else {
          this.custKdCd = 'A'
        }
      }

      if (this.nationality === 'foreigner') {
        this.custKdCd = 'D'
      }
    },
    /** 
     * Function    : validateNationality
     * Description : 입력된 주민번호 뒷자리로 외국인인지 체크하는 함수
     **/
    validateNationality() {
      let title = '온라인 가입신청 안내'
      let message = ''
      if(this.ssn2.substr(0,1) === '5' || this.ssn2.substr(0,1) === '6' || this.ssn2.substr(0,1) === '7' || this.ssn2.substr(0,1) === '8') {
        if (this.nationality === 'korean') {
          message = '외국인일 경우 외국인 구분으로 선택해주세요.'
          this.openAlert(title, message, this.$refs.ref_foreigner_nationality)
          return false
        }
      }
      
      else if(this.ssn2.substr(0,1) === '1' || this.ssn2.substr(0,1) === '2' || this.ssn2.substr(0,1) === '3' || this.ssn2.substr(0,1) === '4' || this.ssn2.substr(0,1) === '0' || this.ssn2.substr(0,1) === '9') {
        if (this.nationality === 'foreigner') {
          message = '내국인일 경우 내국인 구분으로 선택해주세요.'
          this.openAlert(title, message, this.$refs.ref_nationality)
          return false
        }
      }

      else {
        message = '주민번호 뒷자리를 다시 확인해주세요.'
        this.openAlert(title, message, this.$refs.ref_ssn2)
        return false
      }

      return true
    },

    /** 
     * Function    : foreignerAgreePopup
     * Description : 외국인 동의 팝업
     **/
    foreignerAgreePopup() {
      if (!this.foreignerAgree) {
        this.$store.state.isConfirm = false
        this.$modal.show('foreignerAgree')
      }
    },

    /** 
     * Function    : changeNationality
     * Description : 내외국인 radio 변경 이벤트
     **/
    changeNationality() {
      this.name = ''
      this.ssn1 = ''
      this.ssn2 = ''
      this.foreignerAgree = false
    },

    /** 
     * Function    : popupForeignerClose
     * Description : 외국인 동의 팝업 닫힐때 이벤트
     **/
    popupForeignerClose(result) {
      if (result.id === 'ok') {
        this.foreignerAgree = true
      } else {
        this.foreignerAgree = false
      }
    },

    /**
     * Function    : checkTeenager
     * Description : 청소년 검사
     **/
    checkTeenager() {

      var dateObj = new Date(); // 날짜 Object 생성
      var age     = 0; // 나이
      var yy      = dateObj.getFullYear(); // 현재년도
      var mm      = dateObj.getMonth() + 1; // 현재월
      var dd      = dateObj.getDate(); // 현재일

      if (mm < 10) mm = '0' + mm; // 현재 월이 10보다 작을경우 '0' 문자 합한다
      if (dd < 10) dd = '0' + dd; // 현재 일이 10보다 작을경우 '0' 문자 합한다
      var nDate = yy +""+ mm +""+ dd;

      var ssn_no2 = parseInt(this.ssn2.substring(0,1));
      if (ssn_no2 <= 2) {
          age = yy - (1900 + parseInt(this.ssn1.substring(0, 2))); // 1, 2 일경우
      }
      else {
          age = yy - (2000 + parseInt(this.ssn1.substring(0, 2))); // 그 외의 경우
      }

      var myBirthday = this.ssn1.substring(2, 6); // 주민번호 4자리 생일문자 추출

      if (parseInt(nDate) > parseInt(yy + myBirthday)) {
          age += 1;
      }
      age = age - 1; // 만나이
      if(age >= 19) {
        this.isTeenager = false
      } else {
        this.isTeenager = true
      }
    }
  }
}
</script>

<style scoped>
.temp-message-red {
  color: red;
}
</style>
